import { cn, getVersionForClone } from '@qr-front/ui/utils'
import { useTranslations } from 'next-intl'

import { ROUTES } from '@/constants'
import { Link } from '@/i18n-routing'

export function SignUpPageDisclaimer({
	isPopupMode = false,
}: {
	isPopupMode?: boolean
}) {
	const t = useTranslations()
	return (
		<div
			className={cn(
				'text-dark-grey',
				isPopupMode
					? getVersionForClone({
							base: 'type-body-small text-center desktop:text-left',
							clone1: 'type-body-small text-center desktop:text-left',
						})
					: getVersionForClone({
							base: 'text-center text-body-caption',
							clone1: 'text-left text-body-caption',
						}),
			)}
		>
			{t.rich('auth__signup__disclaimer_changed', {
				terms: (chunks) => (
					<Link href={ROUTES.terms} target="_blank" rel="noreferrer">
						{chunks}
					</Link>
				),
				privacy: (chunks) => (
					<Link
						href={ROUTES.privacyPolicy}
						target="_blank"
						rel="noreferrer"
					>
						{chunks}
					</Link>
				),
			})}
		</div>
	)
}
